(function(){
  function init(root){
    var metricButtons=[].slice.call(root.querySelectorAll('.vtpb-metric'));
    var cards=[].slice.call(root.querySelectorAll('.vtpb-benchmark'));
    metricButtons.forEach(function(button){
      button.addEventListener('click',function(){
        var metric=button.getAttribute('data-metric');
        metricButtons.forEach(function(item){var active=item===button;item.classList.toggle('is-selected',active);item.setAttribute('aria-pressed',String(active));});
        cards.forEach(function(card){
          card.querySelectorAll('.vtpb-mini-metric').forEach(function(item){item.classList.toggle('is-focused',item.getAttribute('data-metric')===metric);});
        });
      });
    });
    var toc=root.querySelector('.vtpb-toc');
    var toggle=root.querySelector('.vtpb-toc-toggle');
    var nav=root.querySelector('.vtpb-toc nav');
    if(toc&&toggle&&nav){
      function setToc(open){toc.classList.toggle('is-collapsed',!open);toggle.setAttribute('aria-expanded',String(open));nav.hidden=!open;}
      if(window.matchMedia('(max-width:850px)').matches)setToc(false);
      toggle.addEventListener('click',function(){setToc(toc.classList.contains('is-collapsed'));});
      var navLinks=[].slice.call(nav.querySelectorAll('a'));
      navLinks.forEach(function(link){link.addEventListener('click',function(){if(window.matchMedia('(max-width:850px)').matches)setToc(false);});});
      if('IntersectionObserver' in window){
        var sections=navLinks.map(function(link){return root.querySelector(link.getAttribute('href'));}).filter(Boolean);
        var seen={};
        var observer=new IntersectionObserver(function(entries){
          entries.forEach(function(entry){seen[entry.target.id]=entry.isIntersecting;});
          var current=sections.filter(function(section){return seen[section.id];}).shift();
          if(current)navLinks.forEach(function(link){link.classList.toggle('is-current',link.getAttribute('href')==='#'+current.id);});
        },{rootMargin:'-10% 0px -65% 0px',threshold:0});
        sections.forEach(function(section){observer.observe(section);});
      }
    }
    var checks=[].slice.call(root.querySelectorAll('.vtpb-checklist-steps input[type=checkbox]'));
    var count=root.querySelector('[data-check-count]');
    var progress=root.querySelector('[data-check-progress]');
    checks.forEach(function(check){check.addEventListener('change',function(){
      var selected=checks.filter(function(item){return item.checked;}).length;
      count.textContent=String(selected);progress.style.width=(selected/checks.length*100)+'%';
    });});
    var policySelect=root.querySelector('[data-policy-select]');
    var policyData=root.querySelector('.vtpb-terms-data');
    if(policySelect&&policyData){
      var policies=JSON.parse(policyData.textContent);
      policySelect.addEventListener('change',function(){
        var policy=policies[Number(policySelect.value)];
        root.querySelector('[data-policy-returns]').textContent=policy.returns;
        root.querySelector('[data-policy-warranty]').textContent=policy.warranty;
      });
    }
    var action=root.querySelector('.vtpb-mobile-action');
    var trigger=root.querySelector('.vtpb-certificate');
    if(action&&trigger){
      var actionLink=action.querySelector('a');
      function updateAction(){
        var bottom=trigger.getBoundingClientRect().bottom;
        var visible=bottom<0&&window.innerWidth<=620;
        action.classList.toggle('is-visible',visible);
        action.setAttribute('aria-hidden',String(!visible));
        if(visible){action.removeAttribute('inert');actionLink.removeAttribute('tabindex');}
        else{action.setAttribute('inert','');actionLink.setAttribute('tabindex','-1');}
      }
      window.addEventListener('scroll',updateAction,{passive:true});
      window.addEventListener('resize',updateAction,{passive:true});
      updateAction();
    }
  }
  function start(){document.querySelectorAll('.vtpb').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
})();
